import { Navigate } from 'react-router-dom';

const Roadmap = ()=>  <> <Navigate to='/api/roadmap'/></>
  
export default Roadmap;